module.exports = __webpack_public_path__ + "img/vector-nmny.2e76e307.svg";